import React from "react";
import { files } from "../configs";
import "../NoToken.css";

const NoSetInfo = () => {
  return (
    <div id="app__wrap">
      <div className="container" id="noToken__container">
        <div className="title" id="noToken__title">
          <div className="icon">
            <img src={files + "/warning.svg"} alt="잘못된 접근입니다." />
          </div>
          <h3>조사를 진행할 수 없습니다.</h3>
        </div>
        <div className="content" id="noToken__content">
          <p>
            설정이 완료되지 않아 진행이 불가합니다.
            <br />
            <br />
            자세한 사항은 02-780-0116으로 문의주시면
            <br />
            안내 드리겠습니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoSetInfo;
